import { DEAL_ASSIGNMENT_TYPES } from '@/lib/constants/dealAssignmentTypes'

let getDealAssignmentTypeLabel = (dealAssignmentTypeId) => {
  return DEAL_ASSIGNMENT_TYPES[dealAssignmentTypeId]
}

export default getDealAssignmentTypeLabel
